import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { IconComponent } from '../../../../../../ui/icon/icon.component';

@Component({
  selector: 'app-playback-button',
  templateUrl: './playback-button.component.html',
  styleUrls: ['./playback-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class PlaybackButtonComponent {
  @Input({ required: true }) icon!: string;
  @Output() clickEvent = new EventEmitter<void>();

  onClick(): void {
    this.clickEvent.emit();
  }
}
